// =====================================================================
// static.js — non-translatable: site contact, links, WhatsApp helper.
// All language-agnostic constants live here.
// =====================================================================

export const SITE = {
  name: "Jaipur Tours & Travels",
  domain: "JaipurToursAndTravels.in",
  whatsappNumber: "919606988924",
  whatsappBase: "https://wa.me/919606988924",
  phoneDisplay: "+91 96069 88924",
  email: "bookings@jaipurtoursandtravels.in",
  primaryColor: "#D1603D",
};

export const buildWhatsAppLink = (message) =>
  `${SITE.whatsappBase}?text=${encodeURIComponent(message)}`;

// Static (language-agnostic) shapes shared across en/hi:
//  - vehicle images and pricing per km
//  - route distances and starting prices
//  - package pricing arrays (numbers)
//  - testimonial avatars
//  - article hero images, slugs and publish dates
//
// Per-language wrappers in en.js / hi.js spread these into their objects.

export const FLEET_STATIC = {
  sedan: { image: "/images/fleet/sedan.jpg", pricePerKm: 11, seats: "4" },
  ertiga: { image: "/images/fleet/ertiga.jpg", pricePerKm: 14, seats: "6" },
  innova: { image: "/images/fleet/innova.jpg", pricePerKm: 16, seats: "7" },
  "innova-crysta": { image: "/images/fleet/crysta.jpg", pricePerKm: 18, seats: "7" },
  "tempo-traveller": { image: "/images/fleet/tempo.jpg", pricePerKm: 25, seats: "12 / 16" },
  urbania: { image: "/images/fleet/urbania.jpg", pricePerKm: 32, seats: "12 / 16" },
};

export const ROUTES_STATIC = {
  "jpr-del": { distanceKm: 320, durationHrs: "5h 30m", startingPrice: 4500, image: "https://images.unsplash.com/photo-1587474260584-136574528ed5?w=900&q=80&auto=format&fit=crop" },
  "jpr-agr": { distanceKm: 240, durationHrs: "4h 30m", startingPrice: 4000, image: "https://images.unsplash.com/photo-1564507592333-c60657eea523?w=900&q=80&auto=format&fit=crop" },
  "jpr-ajm": { distanceKm: 135, durationHrs: "2h 30m", startingPrice: 2200, image: "https://images.unsplash.com/photo-1599661046289-e31897846e41?w=900&q=80&auto=format&fit=crop" },
};

export const PACKAGE_STATIC = {
  "jpr-1day": {
    heroImage: "https://images.pexels.com/photos/33290417/pexels-photo-33290417.jpeg?w=1200&auto=compress&cs=tinysrgb",
    pricing: [
      { vehicle: "Sedan", price: 2700 },
      { vehicle: "Ertiga", price: 3700 },
      { vehicle: "Innova", price: 4000 },
      { vehicle: "Innova Crysta", price: 4200 },
      { vehicle: "Tempo Traveller", price: 6250 },
    ],
  },
  "jpr-2day": {
    heroImage: "https://images.pexels.com/photos/28054399/pexels-photo-28054399.jpeg?w=1200&auto=compress&cs=tinysrgb",
    pricing: [
      { vehicle: "Sedan", price: 5800 },
      { vehicle: "Ertiga", price: 7400 },
      { vehicle: "Innova", price: 8600 },
      { vehicle: "Innova Crysta", price: 9400 },
      { vehicle: "Tempo Traveller", price: 12500 },
    ],
  },
  "pilgrim": {
    heroImage: "/images/temples/khatu-shyam.jpg",
    heroImagesData: [
      { key: "khatu-shyam", src: "/images/temples/khatu-shyam.jpg" },
      { key: "salasar", src: "/images/temples/salasar-balaji.jpg" },
      { key: "rani-sati", src: "/images/temples/rani-sati.jpg" },
    ],
    pricing: [
      { vehicle: "Sedan", price: 6050 },
      { vehicle: "Ertiga", price: 7700 },
      { vehicle: "Innova", price: 8800 },
      { vehicle: "Innova Crysta", price: 9900 },
    ],
  },
};

export const TESTIMONIAL_AVATARS = {
  t1: "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&w=200",
  t2: "https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=200",
  t3: "https://images.pexels.com/photos/3992656/pexels-photo-3992656.jpeg?auto=compress&cs=tinysrgb&w=200",
  t4: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=200",
  t5: "https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=200",
  t6: "https://images.pexels.com/photos/762020/pexels-photo-762020.jpeg?auto=compress&cs=tinysrgb&w=200",
};

export const ARTICLE_STATIC = {
  "best-time-to-visit-jaipur": {
    heroImage: "https://images.pexels.com/photos/33290417/pexels-photo-33290417.jpeg?w=1600&auto=compress&cs=tinysrgb",
    publishedAt: "2026-01-15",
    readMinutes: 6,
  },
  "khatu-shyam-darshan-guide": {
    heroImage: "/images/temples/khatu-shyam.jpg",
    publishedAt: "2026-01-22",
    readMinutes: 5,
  },
  "jaipur-to-agra-road-trip": {
    heroImage: "https://images.pexels.com/photos/1603650/pexels-photo-1603650.jpeg?w=1600&auto=compress&cs=tinysrgb",
    publishedAt: "2026-02-03",
    readMinutes: 7,
  },
};

export const ARTICLE_SLUGS = Object.keys(ARTICLE_STATIC);

export const NAV_LINKS_STATIC = [
  { key: "home", href: "/#home" },
  { key: "cabs", href: "/#cabs" },
  { key: "oneway", href: "/#oneway" },
  { key: "packages", href: "/#packages" },
  { key: "customTrip", href: "/#custom" },
  { key: "destinations", href: "/destinations" },
];
